/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Order_Status_MonthInputs */

const vi_dashboard_order_status_month = /** @type {(inputs: Dashboard_Order_Status_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trạng thái đơn hàng tháng này`)
};

/**

* @param {Dashboard_Order_Status_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_order_status_month = /** @type {((inputs?: Dashboard_Order_Status_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Order_Status_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_order_status_month(inputs)
});